/*
  Add a new novel by adding a new object to this array.
  No component code needs to change.

  status: 'coming-soon' | 'released'
    - 'coming-soon' -> clicking the cover opens the email form
    - 'released'    -> clicking the cover should link out (add `link` field)

  heroConfig: optional per-work overrides passed straight into
  renderHeroSection (bgSize, bgPosition, overlayVariant, showSmoke,
  showBgFade, mobileBgPosition). Omit any field to fall back to
  Crow's Tale's original defaults.
*/

export const novels = [
  {
    id: 'novel-01',
    title: 'Dawn of the',
    titleAccent: 'Fanatic',
    subtitle: 'A Nine Deaths Story',
    status: 'coming-soon',
    coverImage: 'https://dgztnhomowsdmaozekhf.supabase.co/storage/v1/object/public/covers/final_clean_4k.png',
    blurb: 'In thirty days, she will purify fifty million souls. But today, she just wants to play.',
    heroConfig: {
      bgSize: 'cover',
      bgPosition: 'center right',
      mobileBgPosition: 'center 28%',
      overlayVariant: 'horizontal-fade',
      showSmoke: false,
      showBgFade: false,
      titleStyle: 'novel',
      ctaHint: 'Chapter I · Free',
    },
  },
];
